// import React, { useMemo, useState } from "react";
// import './CssFiles/indexcss.css'
// import MonthView from "./MonthView";
// import PatientCard from "./PatientCard";

// export default function DemoMonthScheduler() {
//   const [currentDate, setCurrentDate] = useState(new Date(2025, 7, 19)); // Aug 19, 2025
//   const [selectedAppt, setSelectedAppt] = useState(null);

//   // Simple month nav
//   const addMonths = (d, m) => {
//     const nd = new Date(d);
//     nd.setMonth(nd.getMonth() + m);
//     return nd;
//   };

//   // Build 6x7 grid (42 cells)
//   const calendarDays = useMemo(() => {
//     const year = currentDate.getFullYear();
//     const month = currentDate.getMonth(); // 0-based
//     const first = new Date(year, month, 1);
//     const startDay = first.getDay(); // Sun=0
//     const start = new Date(year, month, 1 - startDay);
//     return Array.from({ length: 42 }, (_, i) => {
//       const d = new Date(start);
//       d.setDate(start.getDate() + i);
//       return {
//         day: d.getDate(),
//         date: new Date(d),
//         isCurrentMonth: d.getMonth() === month,
//       };
//     });
//   }, [currentDate]);

//   // ✅ Static demo data
//   const appointments = useMemo(
//     () => [
//       {
//         id: "m1",
//         date: "2025-08-19",
//         startTime: "13:00",
//         Duration: 45,
//         dob: "1985-12-29",
//         patientRequestId: { firstName: "Robert", lastName: "Lee" },
//         doctorRequestId: { firstName: "Nina", lastName: "Singh" },
//         deliveryMode: { name: "Telehealth" },
//         serviceLocationId: { name: "Virtual" },
//         visitReason: { visitReason: "New Patient", cptCode: "99202" },
//         appointmentStatus: { name: "Pending", color: "#ff9800" },
//       },
//       {
//         id: "m2",
//         date: "2025-08-21",
//         startTime: "11:00",
//         Duration: 30,
//         dob: "1978-06-01",
//         patientRequestId: { firstName: "Mina", lastName: "Khan" },
//         doctorRequestId: { firstName: "John", lastName: "Miller" },
//         deliveryMode: { name: "In-Person" },
//         serviceLocationId: { name: "Downtown Center" },
//         visitReason: { visitReason: "Consult", cptCode: "99441" },
//         appointmentStatus: { name: "Checked-In", color: "#2196f3" },
//       },
//       {
//         id: "m3",
//         date: "2025-08-23",
//         startTime: "16:00",
//         Duration: 60,
//         dob: "2001-03-20",
//         patientRequestId: { firstName: "Sara", lastName: "Patel" },
//         doctorRequestId: { firstName: "Akash", lastName: "Gupta" },
//         deliveryMode: { name: "In-Person" },
//         serviceLocationId: { name: "Main Clinic" },
//         visitReason: { visitReason: "Procedure", cptCode: "11042" },
//         appointmentStatus: { name: "Completed", color: "#9c27b0" },
//       },
//     ],
//     []
//   );

//   return (
//     <div className="month-demo">
//       <div className="month-topbar">
//         <button className="month-nav" onClick={() => setCurrentDate(addMonths(currentDate, -1))}>◀</button>
//         <div className="month-title">
//           {currentDate.toLocaleDateString("en-US", { month: "long", year: "numeric" })}
//         </div>
//         <button className="month-nav" onClick={() => setCurrentDate(addMonths(currentDate, 1))}>▶</button>
//       </div>

//       <MonthView
//         calendarDays={calendarDays}
//         appointments={appointments}
//         currentDate={currentDate}
//         onSelectAppointment={setSelectedAppt}
//       />

//       {selectedAppt && (
//         <PatientCard appointment={selectedAppt} onClose={() => setSelectedAppt(null)} />
//       )}
//     </div>
//   );
// }


import React from "react";

function DemoMonthScheduler({
  calendarDays,
  appointments,
  currentDate,
  setSelectedSlot,
  setShowAppointmentPanel,
}) {
  const getAppointmentsForDay = (dayObj) => {
    const fullDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      dayObj.day
    );

    return appointments?.filter((app) => {
      const appDate = new Date(app.date);
      return (
        appDate.getDate() === fullDate.getDate() &&
        appDate.getMonth() === fullDate.getMonth() &&
        appDate.getFullYear() === fullDate.getFullYear()
      );
    });
  };

  const addMinutesToTime = (timeStr, durationStr) => {
    const [hours, minutes] = timeStr.split(":")?.map(Number);
    const durationMinutes = parseInt(durationStr); // e.g., "34 minutes" -> 34
    const start = new Date();
    start.setHours(hours, minutes);
    const end = new Date(start.getTime() + durationMinutes * 60000);

    return `${String(end.getHours()).padStart(2, "0")}:${String(
      end.getMinutes()
    ).padStart(2, "0")}`;
  };

  return (
    <div className="month-view_CalendarView">
      <div className="month-view-header_CalendarView">
        {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]?.map((day) => (
          <div
            key={day}
            style={{
              padding: "10px",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            {day}
          </div>
        ))}
      </div>

      <div className="month-view-grid_CalendarView">
        {calendarDays?.map((dayObj, index) => {
          const appointmentsForDay = getAppointmentsForDay(dayObj);

          // full date object for selected day
          const fullDate = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            dayObj.day
          );

          return (
            <div
              key={index}
              className={`month-view-day_CalendarView ${
                dayObj.isCurrentMonth ? "current-month" : "other-month"
              }`}
              style={{
                color: dayObj.isCurrentMonth ? "#333" : "#999",
                backgroundColor: dayObj.isCurrentMonth ? "#ffffff" : "#f8f9fa",
                padding: "5px",
                cursor: "pointer", 
              }}
         onClick={() => {
  console.log(fullDate, "-=-=-=full=-=-=");
  setSelectedSlot({
    date: fullDate,
    slot: {
      value: 0,        // default midnight
      display: "12:00 AM",
    },
    startTime: "00:00", // default start time
  });
  setShowAppointmentPanel(true);
}}


            >
              <div style={{ fontWeight: "bold" }}>{dayObj.day}</div>

              <div style={{ marginTop: "auto" }}>
                {appointmentsForDay?.map((app, idx) => {
                  const startTime = app.startTime || "00:00";
                  const duration = parseInt(app.Duration?.split(" ")[0] || "0");
                  const endTime = addMinutesToTime(startTime, duration);

                  return (
                    <div
                      key={idx}
                      style={{
                        fontSize: "10px",
                        marginTop: "2px",
                        background: "#e0f7fa",
                        padding: "2px 3px",
                        borderRadius: "4px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        textAlign: "left",
                      }}
                    >
                      <div>
                        <strong>
                          {startTime} - {endTime}
                        </strong>
                      </div>
                      <div>
                        Client: {app?.patientRequestId?.firstName}{" "}
                        {app?.patientRequestId?.lastName}
                      </div>
                      <div>
                        Provider: {app?.doctorRequestId?.firstName}{" "}
                        {app?.doctorRequestId?.lastName}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default DemoMonthScheduler;
